import classNames from 'classnames';
import React from 'react';
import { TemplateClassNames } from '../../../../types/template-layouts';
// import { useParams } from 'react-router';
import { Product } from '../../../../types/working-model';
import { Button } from '../../../general-ui/button/button';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
// import { ParamsProps } from '../../live-event';
import { stylingOverrideReturns } from '../../utils';
import Slider from 'react-slick';
import { settings, PrevArrow, NextArrow } from '../../../admin/create/homepage/editor/products/product';
import { useParams } from 'react-router';
import { ParamsProps } from '../../live-event';

interface ProductItemProps {
	module: Product;
	stylingOverrides: stylingOverrideReturns;
	template: TemplateClassNames;
	onClick: (product: Product) => void;
}

const ProductItem: React.FC<ProductItemProps> = ({ module, stylingOverrides, template, onClick }) => {
	const params: ParamsProps = useParams();
	const language = params.language || 'en';

	const {
		price,
		sale_price,
		product_title,
		description,
		images,
		button_text
	} = module;

	const {
		moduleTitleOverrides,
		moduleCustomHeadingOverrides,
		moduleDescriptionOverrides,
		primaryButtonOverrides
	} = stylingOverrides;

	const defaultButtonText = 'Buy Now'; //TODO: this should probably change but we need to sort out translation for product cards
	return (
		<li className="product" onClick={images.length === 1 ? () => onClick(module) : () => null}>
			<div className={classNames('product-item-image-container')}>
				<Slider
					prevArrow={<PrevArrow />}
					nextArrow={<NextArrow />}
					{...settings}
				>
					{images.map((image: string, index: number) => (
						<React.Fragment key={index}>
							<img src={image} alt={image} aria-hidden="true" />
						</React.Fragment>
					))}
				</Slider>
				{
					sale_price?.[language] && (
						<span className="product-item-label">Sale</span>
					)
				}
			</div>
			<div className="product-item-content" onClick={images.length > 1 ? () => onClick(module) : () => null}>
				<TypographyItem
					className={classNames('product-item-title stable', moduleTitleOverrides, {
						'evt-heading-3': template === TemplateClassNames.Apollo,
						'evt-heading-4': template !== TemplateClassNames.Apollo,
					})}
					tagName="h3"
				>
					{product_title[language]}
				</TypographyItem>
				{/* TODO: implement the currency */}
				<div className="price-container">
					<TypographyItem
						className={classNames('product-item-price stable', moduleCustomHeadingOverrides, {
							'evt-heading-5': template === TemplateClassNames.Apollo || template === TemplateClassNames.O2,
							'evt-caption-1': template === TemplateClassNames['Studio 54'],
						})}
					>
						{price?.base ? (
							`$ ${sale_price?.[language] || price?.[language]}`
						) : null}
					</TypographyItem>
					{(sale_price?.[language] && price?.base) ? (
						<TypographyItem className={classNames('product-item-old-price evt-body-text-2 stable', moduleDescriptionOverrides)}>
							$ {price?.[language]}
						</TypographyItem>
					) : null
					}
				</div>
				<TypographyItem className={classNames(
					'evt-body-text-2 product-item-description',
					moduleDescriptionOverrides,
					{ 'increase-description': !price?.base }
				)} tagName="p">
					{description?.[language]}
				</TypographyItem>
				<Button
					classButton={classNames(
						'primary',
						primaryButtonOverrides
					)}
					template={template}
				>
					{button_text?.[language] || defaultButtonText}
				</Button>
			</div>
		</li>
	);
};

export default ProductItem;
